import { Route, Switch } from "react-router-dom";
import "./App.css";
import { useSelector } from "react-redux";
import ScrollToTop from "./comp/comm/ScrollToTop";

import Header from "./comp/comm/Header";
import MainContents from "./comp/MainContents";
import Page404 from "./comp/sub/Page404";
import Loading from "./comp/comm/Loading";
import Footer from "./comp/comm/Footer";

import MemberList from "./comp/sub/admin/MemberList"; //회원관리 목록
import MemberView from "./comp/sub/admin/MemberView"; //회원관리 수정
import MemberNew from "./comp/sub/admin/MemberNew"; //회원관리 신규
import BannerMgr from "./comp/sub/admin/BannerMgr"; //배너관리
import Login from "./comp/sub/member/Login"; //로그인
import FindAccount from "./comp/sub/member/FindAccount"; //아이디/비밀번호 찾기
import JoinStep01 from "./comp/sub/member/JoinStep01"; //회원가입 Step01
import JoinStep02 from "./comp/sub/member/JoinStep02"; //회원가입 Step02
import JoinStep03 from "./comp/sub/member/JoinStep03"; //회원가입 Step03
import MemberInfo from "./comp/sub/member/MemberInfo"; //내정보수정
import Greetings from "./comp/sub/intro/Greetings"; //인사말
import History from "./comp/sub/intro/History"; //연혁 및 설립목적
import Articles from "./comp/sub/intro/Articles"; //조합정관 및 사업자윤리강령
import Directions from "./comp/sub/intro/Directions"; //찾아오시는 길
import UnionMem from "./comp/sub/unionMem/UnionMem"; //조합원사 현황
import ABoard from "./comp/sub/board/AdminBoardList"; //관리자 작성 가능 게시판 (목록)
import ABoardNew from "./comp/sub/board/AdminBoardNew"; //관리자 작성 가능 게시판 (신규)
import ABoardView from "./comp/sub/board/AdminBoardView"; //관리자 작성 가능 게시판 (내용)
import ABoardEdit from "./comp/sub/board/AdminBoardEdit"; //관리자 작성 가능 게시판 (수정)

function App(props) {
  const store = useSelector((state) => state);

  return (
    <div className="App">
      <Loading loading={store.rdcLoading} />

      <Header />

      <ScrollToTop>
        <Switch>
          {/**************************/}
          {/* 메인화면 component 시작 */}

          <Route exact path="/" component={MainContents} />

          {/* 메인화면 component 끝 */}
          {/**************************/}

          {/**************************/}
          {/* 관리자 메뉴 component 시작 */}

          {/* 회원관리 페이지 */}
          <Route path="/Admin/MemberList" component={MemberList} />
          <Route path="/Admin/MemberView" component={MemberView} />
          <Route path="/Admin/MemberNew" component={MemberNew} />

          {/* 배너관리 페이지 */}
          <Route path="/Admin/BannerMgr" component={BannerMgr} />

          {/* 관리자 메뉴 component 끝 */}
          {/**************************/}

          {/**************************/}
          {/* 회원관련 component 시작 */}

          {/* 로그인페이지 */}
          <Route path="/Login" component={Login} />

          {/* 아이디/비밀번호 찾기 */}
          <Route path="/FindAccount" component={FindAccount} />

          {/* 회원가입 Step01 */}
          <Route path="/JoinStep01" component={JoinStep01} />

          {/* 회원가입 Step02 */}
          <Route path="/JoinStep02" component={JoinStep02} />

          {/* 회원가입 Step03 */}
          <Route path="/JoinStep03" component={JoinStep03} />

          {/* 내정보 수정 */}
          <Route path="/MemberInfo" component={MemberInfo} />

          {/* 회원관련 component 끝 */}
          {/**************************/}

          {/**************************/}
          {/* 조합소개 component 시작 */}

          {/* 인사말 */}
          <Route path="/Greetings" component={Greetings} />

          {/* 연혁 및 설립목적 */}
          <Route path="/History" component={History} />

          {/* 조합정관 및 사업자윤리강령 */}
          <Route path="/Articles" component={Articles} />

          {/* 찾아오시는 길 */}
          <Route path="/Directions" component={Directions} />

          {/* 조합소개 component 끝 */}
          {/**************************/}

          {/**************************/}
          {/* 조합원사 component 시작 */}

          {/* 정비업체현황 현황 */}
          <Route path="/UnionMem" component={UnionMem} />

          {/* 정비업체현황 component 끝 */}
          {/**************************/}

          {/**************************/}
          {/* 문서함 component 시작 */}

          {/* 공지사항, 문서수신, 자료실, 보도자료 */}
          <Route path="/ABoardList" component={ABoard} />
          <Route path="/ABoardNew" component={ABoardNew} />
          <Route path="/ABoardView" component={ABoardView} />
          <Route path="/ABoardEdit" component={ABoardEdit} />

          {/* 정관·규약 */}
          <Route path="/Articles" component={Articles} />

          {/* 문서함 component 끝 */}
          {/**************************/}

          <Route path="/:id" component={Page404} />
        </Switch>
      </ScrollToTop>

      <Footer />
    </div>
  );
}

export default App;
